<template>
  <div>
    <!-- Seção -->
    <v-row
      v-if="option.tipo !== 'secao'"
      class="checkout-h3 accent--text mt-n2"
      no-gutters
      >{{ option.obrigatorio ? `${option.titulo} *` : option.titulo }}</v-row
    >
    <div v-if="option.tipo === 'secao'" class="identification-tag pb-6">
      {{ option.titulo }}
    </div>

    <!-- Input -->
    <v-text-field
      v-else-if="
        option.tipo !== 'nome' &&
        option.tipo !== 'cpf' &&
        option.tipo !== 'cnpj' &&
        option.tipo !== 'localidade' &&
        option.tipo !== 'email' &&
        option.tipo !== 'multipla_escolha' &&
        option.tipo !== 'data' &&
        option.tipo !== 'caixa_selecao' &&
        option.tipo !== 'lista_suspensa' &&
        option.tipo !== 'resposta_longa' &&
        option.tipo !== 'upload_arquivo' &&
        option.tipo !== 'termo_responsabilidade' &&
        option.tipo !== 'paragrafo' &&
        option.tipo !== 'upload_imagem' &&
        option.tipo !== 'horario' &&
        option.tipo !== 'telefone' &&
        option.tipo !== 'documentos'
      "
      ref="ticketName"
      class="rounded-lg"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [validateUnique(option), rulesValidation.required]
          : [validateUnique(option)]
      "
      @keypress.enter="$emit('save')"
      :maxlength="counterField"
      outlined
    ></v-text-field>
    <v-text-field
      v-else-if="option.tipo === 'nome'"
      ref="ticketName"
      class="rounded-lg"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [
              validateUnique(option),
              rulesValidation.required,
              rulesValidation.noSpecialChars,
            ]
          : [validateUnique(option)]
      "
      @keypress.enter="$emit('save')"
      :maxlength="counterField"
      outlined
    ></v-text-field>
    <v-text-field
      v-else-if="option.tipo === 'horario' || option.tipo === 'telefone'"
      ref="ticketName"
      class="rounded-lg"
      v-mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [rulesValidation.required, validateUnique(option)]
          : [validateUnique(option)]
      "
      @keypress.enter="$emit('save')"
      outlined
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'cpf'"
      ref="ticketName"
      class="rounded-lg"
      v-mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [validateUnique(option), rulesValidation.required, cpfRules[1]]
          : [validateUnique(option), cpfRules[1]]
      "
      @keypress.enter="$emit('save')"
      outlined
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'cnpj'"
      ref="ticketName"
      class="rounded-lg"
      v-mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [validateUnique(option), rulesValidation.required, cnpjRules[1]]
          : [validateUnique(option), cnpjRules[1]]
      "
      @keypress.enter="$emit('save')"
      outlined
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'email'"
      ref="ticketName"
      class="rounded-lg"
      v-model="option.valor"
      type="email"
      maxlength="255"
      :rules="
        option.obrigatorio
          ? [
              validateUnique(option),
              rulesValidation.required,
              rulesValidation.email,
            ]
          : [validateUnique(option)]
      "
      @keypress.enter="$emit('save')"
      outlined
    ></v-text-field>

    <!-- input data -->
    <div v-if="option.tipo === 'data'">
      <v-text-field
        background-color="white"
        class="rounded-lg"
        outlined
        @keypress.enter="$emit('save')"
        :rules="
          option.obrigatorio
            ? [
                validateUnique(option),
                rulesValidation.required,
                rulesValidation.dateValid,
              ]
            : [validateUnique(option), rulesValidation.dateValid]
        "
        v-model="option.valor"
        v-mask="getMask(option.tipo)"
        return-masked-value
      >
      </v-text-field>
    </div>

    <!-- Radio Options -->
    <div v-if="option.tipo === 'multipla_escolha'">
      <v-radio-group
        v-model="option.valor"
        :mandatory="true"
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
      >
        <v-radio
          v-for="(opcao, index) in option.opcoes"
          :key="index"
          :label="opcao"
          color="primary"
          :value="opcao"
        ></v-radio>
      </v-radio-group>
    </div>

    <!-- Caixa Seleção -->
    <div v-if="option.tipo === 'caixa_selecao'" class="pb-8">
      <v-checkbox
        style="height: 25px"
        v-model="option.valor"
        :rules="option.obrigatorio ? [(v) => (v && v.length >= 1) || ''] : []"
        color="primary"
        v-for="(opcao, index) in option.opcoes"
        :key="index"
        :label="opcao"
        :value="opcao"
      ></v-checkbox>
    </div>

    <!-- Lista Suspensa -->
    <div v-if="option.tipo === 'lista_suspensa'">
      <v-select
        background-color="white"
        v-model="option.valor"
        :items="option.opcoes"
        item-text="text"
        class="rounded-lg"
        item-value="value"
        outlined
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
      ></v-select>
    </div>

    <!-- Documentos -->
    <div v-if="option.tipo === 'documentos'">
      <v-row no-gutters>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
          :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''"
        >
          <v-select
            v-model="selectedDocument"
            :items="getDocumentsItems(option.opcoes)"
            background-color="white"
            class="rounded-lg"
            outlined
            @change="option.valor = ''"
            :rules="option.obrigatorio ? [rulesValidation.required] : []"
          ></v-select>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
          :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : 'mt-n4'"
        >
          <v-text-field
            v-show="selectedDocument === 'CPF'"
            class="rounded-lg"
            v-model="option.valor"
            :rules="
              option.obrigatorio
                ? selectedDocument === 'CPF'
                  ? [rulesValidation.required, cpfRules[1]]
                  : [rulesValidation.required]
                : selectedDocument === 'CPF'
                ? [cpfRules[1]]
                : []
            "
            @input="option.valor = formatCPF(option.valor)"
            @keypress.enter="$emit('save')"
            outlined
          ></v-text-field>
          <!-- v-mask="getMask(selectedDocument.toLowerCase())" -->
          <v-text-field
            v-show="selectedDocument !== 'CPF'"
            id="testeee"
            class="rounded-lg"
            v-model="option.valor"
            :rules="
              option.obrigatorio
                ? selectedDocument === 'CPF'
                  ? [rulesValidation.required, cpfRules[1]]
                  : [rulesValidation.required]
                : selectedDocument === 'CPF'
                ? [cpfRules[1]]
                : []
            "
            @keypress.enter="$emit('save')"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- Resposta Longa -->
    <div v-if="option.tipo === 'resposta_longa'">
      <v-textarea
        background-color="white"
        outlined
        class="rounded-lg"
        auto-grow
        v-model="option.valor"
        :rules="
          option.obrigatorio
            ? [validateUnique(option), rulesValidation.required]
            : [validateUnique(option)]
        "
        :maxlength="counterField"
      ></v-textarea>
    </div>
    <div id="google-place"></div>
    <div id="google-autocomplete"></div>
    <div v-if="option.tipo === 'localidade'">
      <v-autocomplete
        background-color="white"
        outlined
        v-model="option.valor"
        item-text="description"
        class="rounded-lg"
        :item-value="valueFormated"
        :items="eventPlaces ? eventPlaces : []"
        :loading="!eventPlaces"
        cache-items
        no-data-text="Digite para buscar o local"
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
        :search-input.sync="location"
      ></v-autocomplete>
    </div>

    <!-- Termo Responsabilidade -->
    <div
      v-if="
        option.tipo === 'termo_responsabilidade' || option.tipo === 'paragrafo'
      "
    >
      <div
        class="termo-responsabilidade-item pa-2"
        v-html="option.conteudo"
      ></div>
      <v-checkbox
        v-if="option.obrigatorio && option.tipo !== 'paragrafo'"
        v-model="option.valor"
        :rules="[(v) => !!v || 'Você precisa aceitar os termos!']"
        color="primary"
        label="Li e aceito os termos"
      ></v-checkbox>
    </div>

    <!-- Upload Arquivos -->
    <div
      v-if="option.tipo === 'upload_arquivo' || option.tipo === 'upload_imagem'"
    >
      <v-text-field
        background-color="white"
        outlined
        class="rounded-lg"
        v-model="option.valor"
        @click="onPickFile(option)"
        @click:append="onPickFile(option)"
        append-icon="publish"
      >
      </v-text-field>
      <!-- Hidden -->
      <input
        type="file"
        @change="onFileSelected"
        style="display: none"
        :id="`fileInput-${option.tipo}`"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validationMixin from "../../../mixins/validationMixin.vue";
import { mask, tokens } from "vue-the-mask";
export default {
  props: ["option", "options"],
  directives: { mask, tokens },
  mixins: [validationMixin],
  data() {
    return {
      selectedOption: null,
      isWaitingNameTicket: false,
      order_hash: null,
      location: "",
      locations: [],
      selectedDocument: null,
      tokensx: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
    };
  },
  mounted() {
    if (this.option?.tipo === "documentos") {
      let documents = this.getDocumentsItems(this.option.opcoes);

      this.selectedDocument = documents[0];
    }
  },
  watch: {
    location(v) {
      if (v && v.length >= 3) {
        this.searchLocation(v);
      } else this.$store.commit("SET_ALL_EVENT_PLACES", []);
    },
  },
  computed: {
    ...mapGetters(["eventPlaces"]),

    counterField() {
      if (
        this.option?.tipo === "nome" ||
        this.option?.tipo === "email" ||
        this.option?.tipo === "resposta_curta" ||
        this.option?.tipo === "resposta_longa"
      )
        return 255;

      return null;
    },
  },
  methods: {
    onPickFile(el) {
      this.selectedOption = el;
      setTimeout(function () {
        document.getElementById(`fileInput-${el.tipo}`).click();
      }, 200);
    },
    valueFormated(v) {
      let valueReplace = v.description.replace(", ", " - ").split(" - ");
      return `${valueReplace[0]}/${valueReplace[1]}/${valueReplace[2]}`;
    },
    async searchLocation(v) {
      await this.$store.dispatch("getGlobalPlaces", v);
    },
    onFileSelected(event) {
      if (this.option.tipo === "upload_arquivo") {
        this.option.valor = event.target.value;
        this.option.file = event.target.files[0];
      }
      if (this.option.tipo === "upload_imagem") {
        this.option.valor = event.target.value;
        this.option.image = event.target.files[0];
      }

      this.selectedOption = null;
      this.$forceUpdate();
    },
    getDocumentsItems(options) {
      return options.map((option) => {
        if (option === "rg" || option === "cpf") return option.toUpperCase();
        else if (option === "passaporte") return "Passaporte";
        return option;
      });
    },
    getMask(el) {
      switch (el) {
        case "telefone":
          return "(##) #########";
        case "data":
          return "##/##/####";
        case "horario":
          return "##:##";
        case "cnpj":
          return "##.###.###/####-##";
        case "cpf":
          return "###.###.###-##";
        default:
          return "";
      }
    },
    returnMaked(el) {
      switch (el) {
        case "telefone":
          return false;
        case "data":
          return false;
        case "horario":
          return false;
        case "cnpj":
          return true;
        case "cpf":
          return true;
        default:
          return false;
      }
    },
    async saveNameTicket() {
      this.$emit("save");
    },
    formatCPF(value) {
      return value
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
        .substring(0, 14);
    },

    validateUnique(currentOption) {
      if (!currentOption.unico) return true;
      const duplicates = this.options.filter(
        (opt) =>
          opt.unico &&
          opt.valor === currentOption.valor &&
          opt.codigo !== currentOption.codigo
      );

      return (
        !currentOption.valor ||
        duplicates.length === 0 ||
        "Este valor já foi utilizado."
      );
    },
  },
};
</script>

<style>
.termo-responsabilidade-item p {
  padding: 0px;
  margin: 0px;
}

.identification-tag {
  font-size: 18px;
  font-weight: 800;
}
</style>
